var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{attrs:{"color":"primary","small":"","to":_vm.url}},[_vm._v(_vm._s(_vm.$t("buttons.edit")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }